import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const PrivacyPolicyContentBox = styled.div`
  @media ${breakpoints.s} {
    background-color: ${({ theme }) => theme.Colors.Background.White};
    border: 1px solid ${({ theme }) => theme.Colors.Neutrals.Light};
    padding: ${({ theme }) => theme.UI.SpacingPx.Space10};
  }
`

export { PrivacyPolicyContentBox }
